import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { Link as Link2 } from 'react-router-dom';
import * as Icon from 'react-feather';
import {
    NavbarBrand,
    NavbarToggler,
    NavItem,
    Nav,
    Collapse
} from "reactstrap";

// Import du logo
import logodark from "../assets/images/logo-dark.svg";
import logolight from "../assets/images/logo-dark.svg";

export default function NavbarPage() {
    const [isOpen, setMenu] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            const navbar = document.getElementById("navbar");
            if (
                document.body.scrollTop >= 50 ||
                document.documentElement.scrollTop >= 50
            ) {
                navbar?.classList.add("nav-sticky");
            } else {
                navbar?.classList.remove("nav-sticky");
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const toggleMenu = () => {
        setMenu(!isOpen);
    };

    return (
        <nav id="navbar" className="navbar navbar-expand-lg fixed-top sticky">
            <div className="container">
                <NavbarBrand className="navbar-brand" to="/">
                    <img src={logodark} className="logo-light-mode" alt="Logo clair" />
                    <img src={logolight} className="logo-dark-mode" alt="Logo sombre" />
                </NavbarBrand>

                <NavbarToggler className="navbar-toggler" onClick={toggleMenu}>
                    <Icon.Menu />
                </NavbarToggler>

                <Collapse className={`navbar-collapse ${isOpen ? 'hidden' : 'show'}`} id="navbarSupportedContent">
                    <Nav className="navbar-nav ms-auto mb-2 mb-lg-0" id="navbar-navlist">
                        <NavItem>
                            <Link activeClass="active" spy={true} smooth={true} duration={500} to="home" className="nav-link">Accueil</Link>
                        </NavItem>
                        <NavItem>
                            <Link activeClass="active" spy={true} smooth={true} duration={500} to="features" className="nav-link">Fonctionnalités</Link>
                        </NavItem>
                        <NavItem>
                            <Link activeClass="active" spy={true} smooth={true} duration={500} to="pricing" className="nav-link">Tarifs</Link>
                        </NavItem>
                        <NavItem>
                            <Link activeClass="active" spy={true} smooth={true} duration={500} to="review" className="nav-link">Avis</Link>
                        </NavItem>
                        <NavItem>
                            <Link activeClass="active" spy={true} smooth={true} duration={500} to="blog" className="nav-link">Actualités</Link>
                        </NavItem>
                        {/* <NavItem>
                            <Link activeClass="active" spy={true} smooth={true} duration={500} to="contact" className="nav-link">Contact</Link>
                        </NavItem> */}
                    </Nav>

                    <ul className="list-inline menu-social mb-0 ps-lg-4 ms-2">
                        <li className="list-inline-item ms-2">
                            <Link2 to="https://app.dusyndic.com" className="btn btn-primary text-uppercase">Ouvrir l'application</Link2>
                        </li>
                    </ul>
                </Collapse>
            </div>
        </nav>
    );
}
